import { computed, unref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { usePolicy } from 'dashboard/composables/usePolicy';

// Resolves a route location and checks its meta (featureFlag / permissions /
// installationTypes) against the current user and account, the same way the
// sidebar gates its items.
export function useRouteAccess() {
  const router = useRouter();
  const { shouldShow } = usePolicy();

  const isRouteAllowed = to => {
    if (!to) return false;
    const meta = router.resolve(to)?.meta || {};
    return shouldShow(
      meta.featureFlag,
      meta.permissions,
      meta.installationTypes
    );
  };

  return { isRouteAllowed };
}

// tabs: [{ key, label, icon, to, activeOn: [routeName, ...] }]
// Filters out tabs whose target route the user cannot access and resolves the
// active tab from the current route name.
export function useRouteTabs(tabs) {
  const route = useRoute();
  const { isRouteAllowed } = useRouteAccess();

  const visibleTabs = computed(() =>
    unref(tabs).filter(tab => isRouteAllowed(tab.to))
  );

  const activeTab = computed(() =>
    visibleTabs.value.find(tab => tab.activeOn.includes(route.name))
  );

  return { visibleTabs, activeTab, isRouteAllowed };
}
